import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const EmbedIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20.26 13.94"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 13.94)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4.92 2.4.5 6.84l4.42 4.42M15.34 2.4l4.42 4.43-4.43 4.42M12.24.63 8 13.31" />
    </SVG>
  );
};
